export default {
  articles: {},
  assertions: {},
  assignments: {},
  boards: {},
  contents: {},
  exam_applications: {},
  exam_groups: {},
  exam_modes: {},
  examination_boards: {},
  images: {},
  institutions: {},
  lists: {},
  list_items: {},
  questions: {},
  question_applications: {},
  texts: {},
  solutions: {},
  videos: {},
};
